import React, { useState, useEffect } from "react";
import TopNavigation from "../components/common/TopNavigation";
import useForm from "../components/utilities/useForm"
import { getStateSchema, getValidatorSchema } from "../components/utilities/utilities"
import { useLocation } from "react-router-dom";
import PaymentSuccess from "../components/steps/PaymentSuccess";
import PaymentFailure from "../components/steps/PaymentFailure";
import EpOverlayLoader from "../components/common/EpOverlayLoader";
import { useTranslation } from 'react-i18next';

function NotAvailableEmbassy(props) {
  const step = {};
  step.id = "payment-summary";
  const search = useLocation().search;
  const orderID = new URLSearchParams(search).get('order');
  const paymentType = new URLSearchParams(search).get('payment');
  const stateSchema = getStateSchema();
  const stateValidatorSchema = getValidatorSchema();
  const [state, setState] = useState({
    isLoading: false,
    awb: "",
    printLabelUrl: "",
    printReceiptUrl: "",
    paymentStatus: "",
    firstName: "",
    lastName: "",
    mobileNumber: "",
    emailAddress: ""
  });
  const { t, i18n } = useTranslation();
  const { values, errors, dirty, handleOnChange, setData } = useForm(stateSchema, stateValidatorSchema);






  const properties = { values, errors, dirty, state, t, step }
  console.log(properties);
  return (
    <div>
      <div className="container">
        <TopNavigation {...properties} />
        <div className="row justify-content-md-center mt-3">
          <div className="col-sm-12 col-md-8">
            <div className="payment-summary p-4">
              <div className="row">
                <div className="col-sm-4">
                  <img
                    src="./images/not-found-embassy.svg"
                    alt="not available embassy"
                    className="not-found-icon"
                  />
                </div>
                <div className="col-sm-6 dir-left">
                  <div className="row">
                    <div className="col-sm-12 mt-3">
                      <h2>{t("NOT_AVAILABLE_EMBASSY")}</h2>
                      <div className="col-sm-12 my-4">
                        <p className="p-text">{t("ADDITIONAL_Not_AVAILABLE_EMBASSY")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      {state.isLoading && <EpOverlayLoader text="Loading.... Please wait..." />}
    </div>
  );
}

export default NotAvailableEmbassy;
